
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let t = null;
const store = new Vuex.Store({
  state: {
    matchPriceList: [],//撮合大盘价
  },
  mutations: {
    // 设置撮合大盘价
    setMatchPrice(state, list) {
      state.matchPriceList = list;
    }
  },
  actions: {
    // 设置撮合大盘价
    setMatchPrice({ commit }, list) {
      commit('setMatchPrice', list)
    }
  },
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js